module.exports = __webpack_public_path__ + "static/media/newsletter-bg1.a77da8ea.jpg";